{
  "seo": {
    "title": "FAQ — Parents Ask, We Answer",
    "description": "Answers to common parent questions about safety, free vs paid plans, sibling accounts, cancellations, and learning continuity.",
    "keywords": "faq, is it safe, free vs paid, sibling plan, cancel anytime, parent questions"
  },
  "hero": {
    "tag": "Objection-focused FAQ",
    "title": "Frequently Asked Questions",
    "subtitle": "Quick answers to the questions parents ask before subscribing."
  },
  "items": {
    "safe": {
      "question": "Is CuriPop safe for kids?",
      "answer": "Yes. CuriPop is built for children with parent oversight, child-focused content, and privacy practices aligned to COPPA expectations. We keep controls clear and centralized for families."
    },
    "google": {
      "question": "How is CuriPop different from searching on Google?",
      "answer": "Search engines return mixed results and require heavy filtering. CuriPop gives child-ready answers quickly, with age-appropriate language and parent-friendly oversight built in."
    },
    "family": {
      "question": "What do I get if I pay for the Family plan?",
      "answer": "You get unlimited questions, richer explanations, reading-level personalization, progress tracking, and stronger parent controls across up to five child profiles."
    },
    "siblings": {
      "question": "Can siblings use one plan?",
      "answer": "Yes. One Family plan supports up to five child profiles so each child can have their own progress and personalization."
    },
    "cancel": {
      "question": "Can I cancel anytime?",
      "answer": "Yes. You can cancel from your account settings at any time. If you're in a trial or billing period, access continues until that period ends."
    },
    "continuity": {
      "question": "Do kids continue where they left off?",
      "answer": "Yes. Profiles keep learning continuity so children can return to their progress, topic patterns, and personalized experience across sessions."
    }
  },
  "cta": {
    "title": "Still deciding?",
    "subtitle": "Start free now and review plans only when your family needs more.",
    "primary": "Start Free",
    "secondary": "Compare Plans"
  }
}
